"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseOnSelect = void 0;
var CloseOnSelect = function (target) {
    return /** @class */ (function (_super) {
        __extends(CloseOnSelect, _super);
        function CloseOnSelect() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        CloseOnSelect.prototype.binding = function (select, container) {
            var _this = this;
            _super.prototype.binding.call(this, select, container);
            select.on('select', function (evt) {
                _this._selectTriggered(evt);
            });
            select.on('unselect', function (evt) {
                _this._selectTriggered(evt);
            });
        };
        CloseOnSelect.prototype._selectTriggered = function (evt) {
            var originalEvent = evt.originalEvent;
            // Don't close if the control key is being held
            if (originalEvent && (originalEvent.ctrlKey || originalEvent.metaKey)) {
                return;
            }
            this.trigger('close', {
                originalEvent: originalEvent,
                originalSelect2Event: evt
            });
        };
        return CloseOnSelect;
    }(target));
};
exports.CloseOnSelect = CloseOnSelect;
//# sourceMappingURL=close-on-select.js.map